import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, withKeys as _withKeys, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, createTextVNode as _createTextVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode, createBlock as _createBlock, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = { class: "mt-6" }
const _hoisted_2 = { class: "flex flex-wrap w-full space-y-2 md:space-x-2 md:flex-nowrap md:space-y-0" }
const _hoisted_3 = { class: "flex w-full md:w-2/5" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "bi bi-search",
  viewBox: "0 0 16 16"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z" })
], -1)
const _hoisted_5 = { class: "flex w-full md:w-2/5" }
const _hoisted_6 = { class: "hidden mx-3 my-auto text-lg font-medium capitalize whitespace-nowrap md:block" }
const _hoisted_7 = {
  class: "capitalize",
  value: "all"
}
const _hoisted_8 = ["value"]
const _hoisted_9 = { class: "w-full space-x-2 md:w-1/5" }
const _hoisted_10 = { class: "mt-4 overflow-x-auto min-h-[420px]" }
const _hoisted_11 = { class: "w-full table-auto" }
const _hoisted_12 = { class: "font-bold text-left capitalize border-b-2 border-black divide-x divide-gray-300" }
const _hoisted_13 = {
  scope: "col",
  class: "px-2 py-2 whitespace-nowrap"
}
const _hoisted_14 = { class: "relative flex items-center justify-between" }
const _hoisted_15 = {
  scope: "col",
  class: "px-2 py-2 whitespace-nowrap"
}
const _hoisted_16 = { class: "relative flex items-center justify-between" }
const _hoisted_17 = {
  scope: "col",
  class: "px-2 py-2 whitespace-nowrap"
}
const _hoisted_18 = { class: "relative flex items-center justify-between" }
const _hoisted_19 = {
  scope: "col",
  class: "flex items-center justify-between px-2 py-2"
}
const _hoisted_20 = { class: "relative flex items-center justify-between w-full whitespace-nowrap md:whitespace-normal" }
const _hoisted_21 = { class: "flex items-center" }
const _hoisted_22 = {
  scope: "col",
  class: "px-2 py-2 whitespace-nowrap"
}
const _hoisted_23 = { class: "relative flex items-center justify-between" }
const _hoisted_24 = {
  scope: "col",
  class: "px-2 py-2 whitespace-nowrap"
}
const _hoisted_25 = { class: "relative flex items-center justify-between" }
const _hoisted_26 = {
  scope: "col",
  class: "px-2 py-2 whitespace-nowrap"
}
const _hoisted_27 = { class: "relative flex items-center justify-between" }
const _hoisted_28 = {
  scope: "col",
  class: "px-2 py-2"
}
const _hoisted_29 = { class: "relative flex items-center justify-between w-full" }
const _hoisted_30 = {
  scope: "col",
  class: "px-2 py-2"
}
const _hoisted_31 = { class: "relative flex items-center justify-between w-full" }
const _hoisted_32 = {
  scope: "col",
  class: "px-2 py-2"
}
const _hoisted_33 = { class: "relative flex items-center justify-between w-full" }
const _hoisted_34 = {
  scope: "col",
  class: "px-2 py-2"
}
const _hoisted_35 = { class: "relative flex items-center justify-between w-full" }
const _hoisted_36 = {
  scope: "col",
  class: "px-2 py-2"
}
const _hoisted_37 = { class: "relative flex items-center justify-between w-full" }
const _hoisted_38 = {
  scope: "col",
  class: "px-2 py-2"
}
const _hoisted_39 = { class: "px-2 py-6 space-x-4 capitalize md:py-3 whitespace-nowrap md:whitespace-normal" }
const _hoisted_40 = { class: "px-2 py-2 capitalize whitespace-nowrap md:whitespace-normal" }
const _hoisted_41 = { class: "px-2 py-2 capitalize" }
const _hoisted_42 = { class: "px-2 py-2 capitalize whitespace-nowrap md:whitespace-normal" }
const _hoisted_43 = { key: 0 }
const _hoisted_44 = { key: 1 }
const _hoisted_45 = { class: "px-2 py-2 capitalize whitespace-nowrap md:whitespace-normal" }
const _hoisted_46 = { class: "px-2 py-2 capitalize" }
const _hoisted_47 = { class: "px-2 py-2 capitalize" }
const _hoisted_48 = { key: 0 }
const _hoisted_49 = { key: 1 }
const _hoisted_50 = { key: 0 }
const _hoisted_51 = { key: 1 }
const _hoisted_52 = { class: "px-2 py-2 capitalize" }
const _hoisted_53 = { key: 1 }
const _hoisted_54 = { class: "px-2 py-2 capitalize" }
const _hoisted_55 = { key: 1 }
const _hoisted_56 = { class: "px-2 py-2 capitalize" }
const _hoisted_57 = { class: "px-2 py-2 capitalize" }
const _hoisted_58 = { class: "px-2 py-2 capitalize" }
const _hoisted_59 = { class: "px-2 py-2" }

import { ref } from "vue";
import { useI18n } from "vue-i18n";
import { storeToRefs } from "pinia";
import { useRoute } from "vue-router";

import RoleGuard from "@/components/RoleGuard.vue";
import TitleHeader from "@/components/TitleHeader.vue";
import RouterButton from "@/components/RouterButton.vue";
import PaginationBar from "@/components/PaginationBar.vue";
import ToggleCheckbox from "@/components/ToggleCheckbox.vue";
import FilterTableHeader from "@/components/tables/FilterTableHeader.vue";
import SortableTableHeader from "@/components/tables/SortableTableHeader.vue";

import api from "@/api/api";
import { useGlobalStore, useUserStore } from "@/store";
import { useFilters } from "@/composables/filters";
import { PaginationMeta, User, Event, Template } from "@/types";
import { deserializeSlug } from "@/utils/slugify";
import { userHasRole } from "@/utils/roles";
import { shouldShowColumn } from "@/utils/events";


export default /*#__PURE__*/_defineComponent({
  __name: 'EventsList',
  async setup(__props) {

let __temp: any, __restore: any

const { t: $t } = useI18n();
const route = useRoute();
const globalStore = useGlobalStore();
const { course_types } = storeToRefs(globalStore);
const { userIsAdmin, user } = useUserStore();

const { filters, getFiltersFromQuery, resetFilters, sortBy, setFilter, filter, setFilterNoRefresh } = useFilters(route);

const templates = ref([] as Template[]);
const events = ref([] as Event[]);
const meta = ref({} as PaginationMeta);

const trainers = ref([] as { key: string; value: string }[]);
const locations = ref([] as string[]);

const statusFilters = ref(["all", "draft", "in review", "confirmed", "published", "completed", "cancelled", "unpublished", "no_registrations", "minimum_not_met"]);
const invoiceIssuedFilters = ref(["all", "issued", "not issued"]);
const invoicePaidFilters = ref(["all", "paid", "not-paid"]);
const archivedFilters = [
  { key: "yes", value: "true" },
  { key: "no", value: "false" },
];



async function search() {
  const response = await api.events.listEvents(filters.value as any);
  events.value = response.data.events;
  locations.value = response.data.cities;
  trainers.value = response.data.trainers.map((t: User) => ({ key: `${t.first_name} ${t.last_name}`, value: t.id }));
  meta.value = response.meta;
}

async function markInvoiceIssued(event_id: Event["id"]) {
  try {
    const response = await api.events.markInvoiceAsIssued(event_id);
    const eventIndex = events.value.findIndex(i => i.id === response.data.event.id);

    events.value[eventIndex].invoice_paid = response.data.event.invoice_paid;

    globalStore.toast("SUCCESS", $t("event-invoice-marked-as-issued"));
  } catch (error) {
    console.log(error);
  }
}

async function markInvoicePaid(event_id: Event["id"]) {
  try {
    const response = await api.events.markInvoiceAsPaid(event_id);
    const eventIndex = events.value.findIndex(i => i.id === response.data.event.id);

    events.value[eventIndex].invoice_paid = response.data.event.invoice_paid;

    globalStore.toast("SUCCESS", $t("event-invoice-marked-as-paid"));
  } catch (error) {
    console.log(error);
  }
}

const templatesAll = (
  (
  ([__temp,__restore] = _withAsyncContext(() => api.templates.listTemplates("all", {
    events: true,
  }))),
  __temp = await __temp,
  __restore(),
  __temp
)
).data.templates;
const templatesArchived = (
  (
  ([__temp,__restore] = _withAsyncContext(() => api.templates.listTemplates("all", {
    type: "archived",
    events: true,
  }))),
  __temp = await __temp,
  __restore(),
  __temp
)
).data.templates;

templates.value = templatesAll.concat(templatesArchived).sort((a, b) => a.name.localeCompare(b.name));

setFilterNoRefresh("status", "all");
setFilterNoRefresh("sort", "first_event_date");
setFilterNoRefresh("dir", "asc");
setFilterNoRefresh("page", "1");
setFilterNoRefresh("archived", "false");

if(userHasRole(user.roles, ["admin"])) {
  setFilterNoRefresh("status", "published");
} else


if(userHasRole(user.roles, ["trainer-organisation", "facilitator-organisation"])) {
  setFilterNoRefresh("added_by_user", "true");
}

getFiltersFromQuery();
;(
  ([__temp,__restore] = _withAsyncContext(() => search())),
  await __temp,
  __restore()
);

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _createVNode(TitleHeader, {
        title: _unref($t)('training-events')
      }, null, 8, ["title"])
    ]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _withDirectives(_createElementVNode("input", {
            type: "search",
            id: "search",
            onKeydown: _cache[0] || (_cache[0] = _withKeys(($event: any) => (_unref(setFilter)('search', _unref(filters).query)), ["enter"])),
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(filters).query) = $event)),
            class: "block w-full h-10 py-2 text-gray-900 border border-gray-600 rounded-l",
            placeholder: "Search ...",
            required: ""
          }, null, 544), [
            [_vModelText, _unref(filters).query]
          ]),
          _createElementVNode("button", {
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(setFilter)('search', _unref(filters).query))),
            class: "flex items-center h-10 px-4 py-2 space-x-2 text-white rounded-r whitespace-nowrap bg-primary hover:bg-blue-700"
          }, [
            _hoisted_4,
            _createElementVNode("span", null, _toDisplayString(_unref($t)("search")), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("label", _hoisted_6, _toDisplayString(_unref($t)("course-type")), 1),
          _withDirectives(_createElementVNode("select", {
            id: "subscription",
            class: "capitalize text-black border rounded w-full focus:outline-none focus:shadow-outline-primary font-normal transition duration-50 ease-in px-3 py-1.5 h-10 border-gray-600",
            onChange: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_unref(filter) && _unref(filter)(...args))),
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(filters).type) = $event))
          }, [
            _createElementVNode("option", _hoisted_7, _toDisplayString(_unref($t)("all")), 1),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(course_types), (t) => {
              return (_openBlock(), _createElementBlock("option", {
                class: "capitalize",
                value: t.slug,
                key: t.slug
              }, _toDisplayString(_unref($t)(t.slug)), 9, _hoisted_8))
            }), 128))
          ], 544), [
            [_vModelSelect, _unref(filters).type]
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createVNode(RoleGuard, { roles: ['admin', 'trainer-organisation', 'l4a-trainer', 'courses-admin'] }, {
            default: _withCtx(() => [
              _createVNode(RouterButton, {
                type: "secondary",
                loading: false,
                disabled: false,
                to: { path: '/dashboard/courses/events/new' }
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref($t)("add-event")), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("table", _hoisted_11, [
          _createElementVNode("thead", null, [
            _createElementVNode("tr", _hoisted_12, [
              _createElementVNode("th", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("span", null, _toDisplayString(_unref($t)(`event-name`)), 1),
                  _createVNode(FilterTableHeader, {
                    label: "template_id",
                    currentValue: _unref(filters).template_id,
                    filters: 
                    templates.value.filter(i => i.events!.length > 0).map(i => {
                      return { key: i.name, value: i.id };
                    })
                  ,
                    isObjectArray: "",
                    onChange: _unref(setFilter),
                    onReset: _unref(resetFilters)
                  }, null, 8, ["currentValue", "filters", "onChange", "onReset"])
                ])
              ]),
              _createElementVNode("th", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("span", null, _toDisplayString(_unref($t)(`course-type`)), 1),
                  _createVNode(SortableTableHeader, {
                    column: "type",
                    onSort: _unref(sortBy)
                  }, null, 8, ["onSort"])
                ])
              ]),
              _createElementVNode("th", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("span", null, _toDisplayString(_unref($t)(`location`)), 1),
                  _createVNode(FilterTableHeader, {
                    label: "location",
                    currentValue: _unref(filters).location,
                    filters: locations.value,
                    onChange: _unref(setFilter),
                    onReset: _unref(resetFilters)
                  }, null, 8, ["currentValue", "filters", "onChange", "onReset"]),
                  _createVNode(SortableTableHeader, {
                    column: "city",
                    onSort: _unref(sortBy)
                  }, null, 8, ["onSort"])
                ])
              ]),
              _createElementVNode("th", _hoisted_19, [
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("span", null, _toDisplayString(_unref($t)(`first-delivery-date`)), 1),
                  _createElementVNode("div", _hoisted_21, [
                    _createVNode(FilterTableHeader, {
                      label: "timeframe",
                      currentValue: _unref(filters).timeframe,
                      filters: ['week', 'month'],
                      onChange: _unref(setFilter),
                      onReset: _unref(resetFilters)
                    }, null, 8, ["currentValue", "onChange", "onReset"]),
                    _createVNode(SortableTableHeader, {
                      column: "first_event_date",
                      onSort: _unref(sortBy)
                    }, null, 8, ["onSort"])
                  ])
                ])
              ]),
              _createElementVNode("th", _hoisted_22, [
                _createElementVNode("div", _hoisted_23, [
                  _createElementVNode("span", null, _toDisplayString(_unref($t)(`trainer`)), 1),
                  _createVNode(FilterTableHeader, {
                    label: "trainer",
                    currentValue: _unref(filters).trainer,
                    filters: trainers.value,
                    onChange: _unref(setFilter),
                    onReset: _unref(resetFilters),
                    "is-object-array": true
                  }, null, 8, ["currentValue", "filters", "onChange", "onReset"])
                ])
              ]),
              _createElementVNode("th", _hoisted_24, [
                _createElementVNode("div", _hoisted_25, [
                  _createElementVNode("span", null, _toDisplayString(_unref($t)(`attendees`)), 1),
                  _createVNode(SortableTableHeader, {
                    column: "total_bookings",
                    onSort: _unref(sortBy)
                  }, null, 8, ["onSort"])
                ])
              ]),
              _createElementVNode("th", _hoisted_26, [
                _createElementVNode("div", _hoisted_27, [
                  _createElementVNode("span", null, _toDisplayString(_unref($t)(`max-attendees`)), 1)
                ])
              ]),
              (_unref(userIsAdmin))
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createElementVNode("th", _hoisted_28, [
                      _createElementVNode("div", _hoisted_29, [
                        _createElementVNode("span", null, _toDisplayString(_unref($t)(`invoice-issued`)), 1),
                        _createVNode(FilterTableHeader, {
                          label: "invoice_issued",
                          currentValue: _unref(filters).invoice_issued,
                          filters: invoiceIssuedFilters.value,
                          onChange: _unref(setFilter),
                          onReset: _unref(resetFilters)
                        }, null, 8, ["currentValue", "filters", "onChange", "onReset"])
                      ])
                    ]),
                    _createElementVNode("th", _hoisted_30, [
                      _createElementVNode("div", _hoisted_31, [
                        _createElementVNode("span", null, _toDisplayString(_unref($t)(`invoice-paid`)), 1),
                        _createVNode(FilterTableHeader, {
                          label: "invoice_paid",
                          currentValue: _unref(filters).invoice_paid,
                          filters: invoicePaidFilters.value,
                          onChange: _unref(setFilter),
                          onReset: _unref(resetFilters)
                        }, null, 8, ["currentValue", "filters", "onChange", "onReset"])
                      ])
                    ])
                  ], 64))
                : _createCommentVNode("", true),
              _createElementVNode("th", _hoisted_32, [
                _createElementVNode("div", _hoisted_33, [
                  _createElementVNode("span", null, _toDisplayString(_unref($t)(`payment-status`)), 1),
                  _createVNode(SortableTableHeader, {
                    column: "invoice_paid",
                    onSort: _unref(sortBy)
                  }, null, 8, ["onSort"])
                ])
              ]),
              _createElementVNode("th", _hoisted_34, [
                _createElementVNode("div", _hoisted_35, [
                  _createElementVNode("span", null, _toDisplayString(_unref($t)(`training-status`)), 1),
                  _createVNode(FilterTableHeader, {
                    label: "status",
                    currentValue: _unref(filters).status,
                    filters: statusFilters.value,
                    onChange: _unref(setFilter),
                    onReset: _unref(resetFilters)
                  }, null, 8, ["currentValue", "filters", "onChange", "onReset"])
                ])
              ]),
              _createElementVNode("th", _hoisted_36, [
                _createElementVNode("div", _hoisted_37, [
                  _createElementVNode("span", null, _toDisplayString(_unref($t)("archived")), 1),
                  _createVNode(FilterTableHeader, {
                    label: "archived",
                    currentValue: _unref(filters).archived,
                    filters: archivedFilters,
                    onChange: _unref(setFilter),
                    onReset: _unref(resetFilters),
                    isObjectArray: true
                  }, null, 8, ["currentValue", "onChange", "onReset"])
                ])
              ]),
              _createElementVNode("th", _hoisted_38, _toDisplayString(_unref($t)("actions")), 1)
            ])
          ]),
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(events.value, (event) => {
              return (_openBlock(), _createElementBlock("tr", {
                class: "border-b border-gray-400 divide-x divide-gray-300",
                key: event.id
              }, [
                _createElementVNode("td", _hoisted_39, [
                  _createElementVNode("span", null, _toDisplayString(event.name) + " (#" + _toDisplayString(event.id) + ")", 1)
                ]),
                _createElementVNode("td", _hoisted_40, _toDisplayString(_unref(shouldShowColumn)(_unref(user), event) ? _unref(deserializeSlug)(event.type) : "N/A"), 1),
                _createElementVNode("td", _hoisted_41, _toDisplayString(event.city ? event.city : _unref($t)("online")), 1),
                _createElementVNode("td", _hoisted_42, [
                  (event.template.delivery !== 'e-learning' && event.first_event_date)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_43, _toDisplayString(new Date(event.first_event_date!).toLocaleDateString("en-GB", { year: "numeric", month: "long", day: "numeric" })), 1))
                    : (_openBlock(), _createElementBlock("span", _hoisted_44, " N/A"))
                ]),
                _createElementVNode("td", _hoisted_45, _toDisplayString(event.owner.first_name) + " " + _toDisplayString(event.owner.last_name), 1),
                _createElementVNode("td", _hoisted_46, [
                  _createVNode(RoleGuard, { roles: ['admin', 'courses-admin', 'clubs-admin', 'users-admin', 'l4a-trainer'] }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(event.total_bookings), 1)
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(RoleGuard, { roles: ['trainer-organisation', 'facilitator-organisation'] }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(shouldShowColumn)(_unref(user), event) ? event.total_bookings : "N/A"), 1)
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _createElementVNode("td", _hoisted_47, [
                  _createVNode(RoleGuard, { roles: ['admin', 'courses-admin', 'clubs-admin', 'users-admin'] }, {
                    default: _withCtx(() => [
                      (event.template.delivery !== 'e-learning')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_48, _toDisplayString(event.max_attendees > 0 ? `${event.total_bookings}/${event.max_attendees}` : "N/A"), 1))
                        : (_openBlock(), _createElementBlock("span", _hoisted_49, " N/A"))
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(RoleGuard, { roles: ['trainer-organisation', 'facilitator-organisation', 'l4a-trainer'] }, {
                    default: _withCtx(() => [
                      (event.template.delivery !== 'e-learning')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_50, _toDisplayString(_unref(shouldShowColumn)(_unref(user), event) ? (event.max_attendees > 0 ? `${event.total_bookings}/${event.max_attendees}` : "N/ A") : "N/A"), 1))
                        : (_openBlock(), _createElementBlock("span", _hoisted_51, " N/A"))
                    ]),
                    _: 2
                  }, 1024)
                ]),
                (_unref(userIsAdmin))
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createElementVNode("td", _hoisted_52, [
                        (!event.is_play_event)
                          ? (_openBlock(), _createBlock(ToggleCheckbox, {
                              key: 0,
                              onToggle: ($event: any) => (markInvoiceIssued(event.id)),
                              value: event.invoice_issued ? true : false
                            }, null, 8, ["onToggle", "value"]))
                          : (_openBlock(), _createElementBlock("span", _hoisted_53, _toDisplayString(event.invoice_issued ? _unref($t)("yes") : _unref($t)("no")), 1))
                      ]),
                      _createElementVNode("td", _hoisted_54, [
                        (!event.is_play_event)
                          ? (_openBlock(), _createBlock(ToggleCheckbox, {
                              key: 0,
                              onToggle: ($event: any) => (markInvoicePaid(event.id)),
                              value: event.invoice_paid ? true : false
                            }, null, 8, ["onToggle", "value"]))
                          : (_openBlock(), _createElementBlock("span", _hoisted_55, _toDisplayString(event.invoice_paid ? _unref($t)("paid") : _unref($t)("no")), 1))
                      ])
                    ], 64))
                  : _createCommentVNode("", true),
                _createElementVNode("td", _hoisted_56, _toDisplayString(_unref(shouldShowColumn)(_unref(user), event) ? (event.invoice_paid ? _unref($t)("paid") : _unref($t)("pending")) : "N/a"), 1),
                _createElementVNode("td", _hoisted_57, _toDisplayString(_unref(shouldShowColumn)(_unref(user), event) ? _unref($t)(event.status) : "N/A"), 1),
                _createElementVNode("td", _hoisted_58, _toDisplayString(event.archived ? _unref($t)("yes") : _unref($t)("no")), 1),
                _createElementVNode("td", _hoisted_59, [
                  _createVNode(_component_router_link, {
                    to: `/dashboard/courses/events/${event.id}?tab=registered_attendees`,
                    class: "text-blue"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref($t)("view")), 1)
                    ]),
                    _: 2
                  }, 1032, ["to"])
                ])
              ]))
            }), 128))
          ])
        ])
      ]),
      _createVNode(PaginationBar, { meta: meta.value }, null, 8, ["meta"])
    ])
  ], 64))
}
}

})